import routers from "@/router/module";

export default {
    state: {
        navList: routers,
        appEnv: {},
    },
    getters: {
        getAppEnv: (state) => state.appEnv
    },
    mutations: {
        setNavList(state, list) {
            let navList = [];
            if (list) {
                navList = [...list];
            } else navList = [...routers] || [];
            state.navList = navList;

            // console.log(state.navList);
        },
        setAppEnv(state, appEnv) {
            state.appEnv = appEnv
            localStorage.setItem('APPENV', appEnv.appEnv)
        }
    },
    actions: {},
};
